import { Box, Flex, Text } from '@chakra-ui/react';
import Image from 'next/image';

const ContentWithImage = ({ content }) => {
  const { orientation, heading, body, image, alt } = content;

  return (
    <Flex flexDir={['column', 'column', orientation]} my="50px" align="center">
      <Box w={['100%', '100%', '50%']}>
        <Text textStyle="emphasis" mb={3}>
          {heading}
        </Text>
        <Text textStyle="p">{body}</Text>
      </Box>
      <Box
        w={['100%', '100%', '50%']}
        height={['200px', '200px', '200px', '300px']}
        mt={[10, 10, 0]}
        mx="auto"
        position="relative"
      >
        <Image src={image} alt={alt} fill />
      </Box>
    </Flex>
  );
};

export default ContentWithImage;
